import { Component, Input } from '@angular/core';
import { StorageService } from '../../../../core/services/storage.service';
import { UtilService } from '../../../../core/services/util.service';
import Event from '../../../../core/models/event';

@Component({
  selector: 'event-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css'],
})
export class CardComponent {
  @Input() event: Event | null = null;

  constructor(
    private localStorageService: StorageService,
    private utilService: UtilService
  ) {}

  getEventUrl(): string {
    return this.event ? `/event/${this.event.slug}` : '#';
  }

  getImageUrl(): string {
    return this.utilService.getAbsoluteUrl(this.event?.coverUri ?? '');
  }

  get displayMinPrice(): number {
    if (!this.event) return 0;
    const prices: number[] = [];

    if (this.event.minPrice && this.event.minPrice > 0) prices.push(this.event.minPrice);
    if (this.event.minDonationPrice && this.event.minDonationPrice > 0) prices.push(this.event.minDonationPrice);

    if (prices.length === 0) return 0;

    return Math.min(...prices);
  }

  get displayMaxPrice(): number {
    if (!this.event) return 0;
    const prices: number[] = [];

    if (this.event.maxPrice && this.event.maxPrice > 0) prices.push(this.event.maxPrice);
    if (this.event.maxDonationPrice && this.event.maxDonationPrice > 0) prices.push(this.event.maxDonationPrice);

    if (prices.length === 0) return this.displayMinPrice; // Fallback to min if max is 0

    return Math.max(...prices);
  }

  get isFree(): boolean {
    if (!this.event) return false;
    return this.event.free && !this.event.minDonationPrice;
  }
}
